import {
  Component,
  OnInit,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { Router } from '@angular/router';
import { BrandService } from '../../../../services/brandservice';
import { UrlSlugifyService } from '../../../../services/url-slugify';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-allbrands',
  templateUrl: './allbrands.component.html',
  styleUrl: './allbrands.component.scss'
})
export class AllbrandsComponent implements OnInit {

  contentReady = true;
  allBrands!: any;
  isAr = false;
  private isBrowser: boolean;

  constructor(
    private router: Router,
    private _brand: BrandService,
    private _slugify: UrlSlugifyService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

    // ⛔ السيرفر يقف هنا
    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }

    this.getAllbrands();
  }

  getAllbrands(isLocalBrand?: 0 | 1): void {
    this.contentReady = true;

    this._brand.getAllBrands(isLocalBrand).subscribe({
      next: (data) => {
        this.allBrands = data;
        this.contentReady = false;
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  bybrand(brand: any): void {
    this.router.navigate([
      '/brand',
      this._slugify.slugify(this.isAr ? brand.brandname_ar : brand.brandname_en),
      brand.id
    ]);
  }

  fixImage(url: string): string {
    return `https://backendproduction.blueboxpet.com/storage/app/public/${url}`;
  }
}
